module.exports = __webpack_public_path__ + "img/img_030@2x.83a21ed7.png";